import { IconButton } from "@material-ui/core";
import * as React from "react";

import "./BackgroundLogin.scss";

// tslint:disable-next-line:no-empty-interface
export interface IBackgroundLoginProps {}

// tslint:disable-next-line:no-empty-interface
export interface IBackgroundLoginState {}

export class BackgroundLogin extends React.Component<IBackgroundLoginProps, IBackgroundLoginState> {
  constructor(props: IBackgroundLoginProps) {
    super(props);
  }

  public goToWhatsapp () {
    return window.open('https://wa.me/message/LMGCB4KBHQ4XP1', '#')
  }

  public render() {
    return (
      <div className="background-login-body">
        <div className="background-login-card">
          <header className="background-login-header" />
          {this.props.children}
        </div>
        <IconButton className='footer-button' onClick={() => this.goToWhatsapp()} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/background-login/BackgroundLogin.tsx